import React from 'react';
import styles from './TextInput.scss';

const TextInput = ({
  hidden,
  width,
  placeholder,
  value,
  maxlength,
  onBlur,
  onChange,
  disabled,
  uppercase,
  error,
}) => {
  return (
    <input
      type={hidden ? 'password' : 'text'}
      disabled={!!disabled}
      className={[styles.text_input, error ? styles.error : '', uppercase ? styles.uppercase : ''].join(' ')}
      style={{ width }}
      maxLength={maxlength}
      placeholder={placeholder}
      autoComplete="off"
      value={value}
      onChange={onChange}
      onBlur={onBlur} />
  );
};


export default TextInput;
